export async function enableTrackAllChanges() {
  await window.Word.run(async context => {
    context.document.changeTrackingMode = Word.ChangeTrackingMode.trackAll;
    await context.sync();
  });
}
